import crudlModuleGenerator from '@/_CRUDL/modules/generator';

export default crudlModuleGenerator('banksPartners', {
  customKeys: {
    list: 'banks',
  },
  customEndpoints: {
    list: '/banks/partners',
  },
});
